// pages/Error403.jsx
import { Link } from "react-router-dom";

function Error403() {
  return (
    <div className="d-flex vh-100 justify-content-center align-items-center">
      <div className="text-center">
        <h1 className="text-danger">403</h1>
        <h4>Access Denied</h4>
        <p>You do not have permission to access this page.</p>
        <Link to="/dashboard" className="btn btn-primary mt-3">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}

export default Error403;